<template>
	<section id="paquetes">
		<div id="breadcrumbs">
			<div class="bg-light py-3">
				<div class="container">
					<div class="row">
						<div class="col-md-12 mb-0 text-left">
							<router-link to="/">Home</router-link> <span class="mx-2 mb-0">/</span> <strong class="text-black">Paquetes</strong>
						</div>
					</div>
				</div>
			</div>
		</div><!-- #breadcrumbs -->
		<img loading="lazy" src="images/img_estilos/Paquetes desk.svg" alt="paquete" width="225" height="100">
		<loading :active.sync="is_loading"></loading>
		<ProductList :no_product="message" :products="products"></ProductList>
	</section>
</template>

<script>
// @ is an alias to /src
import ProductList from '@/components/ProductList.vue';
import Loading from 'vue-loading-overlay';
const axios = require('axios');

export default {
	name: 'paquete',
	data(){
		return {
			api_url: process.env.VUE_APP_SUSCRIPTIONS_ROUTE,
			products: [],
			message: "",
			is_loading: true
		}
	},
	mounted(){
		this.getPaquetes();
	},
	components: {
		ProductList,
		Loading
	},
	methods: {
		getPaquetes: function(){
			this.message = "Cargando paquetes"
			axios({
				method: 'GET',
				url: this.api_url+'/products/type/4',
				headers: {'Content-Type': 'application/json', 'Authorization': 'Bearer '+$cookies.get('ctoken')}
			})
			.then(response => {
				this.products = response.data;
				console.info('Se obtuvieron los paquetes');
				console.info(response.data);
				this.is_loading = false;
				if (this.products.length > 0)
					this.message = "Se obtuvieron los paquetes";
				else
					this.message = "No se encontraron paquetes que mostrar";
			})
			.catch(error => {
				console.error(error);
				this.message = "No se encontraron paquetes que mostrar";
			});
		}
	}
}
</script>
